import { AutogenLayoutSettlementJournalReport } from "./autogen/AutogenLayoutSettlementJournalReport";

export class SettlementJournalReport extends AutogenLayoutSettlementJournalReport {
    override onLoad(): void {
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
    }

    reportTypeChanged() {
        const reportType = this.textboxReportType.text

        if (reportType.startsWith("Totals Only")) {
            this.switchSort.enabled = false;
        } else {
            this.switchSort.enabled = true;
        }

    }
}
